// A customer as the Usage tab names them. Deleted accounts keep the name they had;
// a usage row whose user record is gone entirely has none.
export function customerName(row) {
  const name = [row.firstName, row.lastName].filter(Boolean).join(" ");
  return name || row.email || row.companyName || "Unknown customer";
}
